/* Snoozer Therapy theme: winkelwagen (cart drawer, /cart, header-bolletje) op de Shopify AJAX Cart API
   (/cart.js, /cart/add.js, /cart/change.js, /cart/update.js). Variant-ID's komen uit Liquid (window.SZ, layout/theme.liquid).
   Markup van drawer/regels/cartpagina is letterlijk de live markup. */
(function () {
  'use strict';
 var T = {
  drawerInner: ({ count, progress, rows, total, original, savings, upsell }) => `<div class="drawer__header">
        <h2 class="drawer__heading">
          Cart<span class="drawer__cart-count">${count}</span></h2>
        <button class="drawer__close" type="button" onclick="this.closest('cart-drawer').close()" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
  <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
</path></svg>

        </button>
      </div>
      
      
        










${progress}<div class="cart-drawer-items-and-upsell">
        <cart-drawer-items>
          <form action="/cart" id="CartDrawer-Form" class="cart__contents cart-drawer__form" method="post">
            <div id="CartDrawer-CartItems" class="drawer__contents js-contents"><div class="drawer__cart-items-wrapper">
                  <table class="cart-items" role="table">
                    <thead role="rowgroup">
                      <tr role="row">
                        <th id="CartDrawer-ColumnProductImage" role="columnheader">
                          <span class="visually-hidden">Product image</span>
                        </th>
                        <th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">
                          Product
                        </th>
                        <th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">
                          Total
                        </th>
                        <th id="CartDrawer-ColumnQuantity" role="columnheader">
                          <span class="visually-hidden">Quantity</span>
                        </th>
                      </tr>
                    </thead>

                    <tbody role="rowgroup">${rows}</tbody>
                  </table>
                </div><p id="CartDrawer-LiveRegionText" class="visually-hidden" role="status"></p>
              <p id="CartDrawer-LineItemStatus" class="visually-hidden" aria-hidden="true" role="status">
                Loading...
              </p>
            </div>
            <div id="CartDrawer-CartErrors" role="alert"></div>
          </form>
        </cart-drawer-items>
        
          ${upsell}<style>
  .cpu-wrap { margin: 12px 0; padding: 0 4px; }
  .cpu-heading { text-align: center; font-family: 'Jost', -apple-system, sans-serif; font-weight: 700; font-size: 18px; margin: 0 0 12px; color: #14161a; }
  .cpu-item { display: flex; gap: 10px; align-items: center; background: #ffffff; border: 1px solid #e8e8ea; border-radius: 14px; padding: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.04); min-width: 0; }
  .cpu-item__image { flex: 0 0 64px; }
  .cpu-item__image img { width: 64px; height: 64px; object-fit: contain; border-radius: 10px; background: #f2f3f5; }
  .cpu-item__content { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
  .cpu-item__title { font-family: 'Jost', -apple-system, sans-serif; font-weight: 700; font-size: 14px; color: #14161a; line-height: 1.25; }
  .cpu-item__sub { font-size: 12px; color: #6b7280; line-height: 1.3; }
  .cpu-item__row { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
  .cpu-item__price { font-weight: 700; font-size: 14px; color: #14161a; }
  .cpu-item__btn { flex-shrink: 0; background: #68A7FA; color: #ffffff; font-family: 'Jost', -apple-system, sans-serif; font-weight: 700; font-size: 13px; border: none; padding: 7px 12px; border-radius: 6px; cursor: pointer; }
  .cpu-item__btn:hover { background: #4a8fe8; }
  .cpu-item__btn.is-loading { opacity: 0.6; cursor: wait; }
</style>

</div>
      <div class="drawer__footer">
        
          
<style>
  /* Hide the e-book product card from every collection grid, related products and search — it only exists as an automatic cart gift */
  li.grid__item:has(a[href*="side-sleepers-guide"]),
  li.grid__item:has(a[href*="side-sleeper-s-guide"]),
  .grid__item:has(a[href*="the-side-sleeper"]),
  .card-wrapper:has(a[href*="the-side-sleeper"]),
  .related-products__item:has(a[href*="the-side-sleeper"]),
  predictive-search li:has(a[href*="the-side-sleeper"]) {
    display: none !important;
  }
  /* Gift line: hide quantity controls + remove, it lives and dies with the pillow */
  #CartDrawer .cart-item:has(a[href*="side-sleeper"]) .quantity,
  #CartDrawer .cart-item:has(a[href*="side-sleeper"]) cart-remove-button {
    display: none !important;
  }
  /* Gift line: hide native €0,00 price — JS injects Free gift + €19,00 */
  #CartDrawer .cart-item:has(a[href*="side-sleeper"]) .cart-item__price-wrapper > .price,
  #CartDrawer .cart-item:has(a[href*="side-sleeper"]) .cart-item__price-wrapper > .cart-item__discounted-prices {
    display: none !important;
  }
  .snz-gift-price{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
  }
  .snz-gift-price__label{
    font-size: 1.05rem;
    font-weight: 700;
    color: #14161a;
    white-space: nowrap;
  }
  /* Pillow line: hide native discounted old price, JS injects compare-at instead */
  #CartDrawer .cart-item:has(a[href*="improved-leg-pillow"]) .cart-item__discounted-prices .cart-item__old-price:not(.snz-cmp) {
    display: none !important;
  }
  #CartDrawer .snz-cmp{
    display: block;
    font-size: 0.82rem;
    font-weight: 500;
    color: #9a9fa9;
    text-decoration: line-through;
    white-space: nowrap;
    text-align: right;
    margin-top: 2px;
  }
</style>

        
        
<!-- Start blocks -->
        <!-- Subtotals -->

        <div class="cart-drawer__footer">
          <div class="totals" role="status">
            <h2 class="totals__subtotal">Total</h2>
            <div class="totals__value-wrap">
              <div class="totals__price-row">
                <span class="totals__subtotal-value">${total}</span>${original}</div>${savings}</div>
          </div>

          <div></div>
        </div>

        <!-- CTAs -->

        <div class="cart__ctas">
          <noscript>
            <button type="submit" class="cart__update-button button button--secondary" form="CartDrawer-Form">
              Update
            </button>
          </noscript>

          <button type="submit" id="CartDrawer-Checkout" class="cart__checkout-button button" name="checkout" form="CartDrawer-Form">
            Check out
          </button>
        </div>

        
        
<div class="snz-cart-trustrow">
            <div class="snz-cart-trustrow__item">
              <span class="snz-cart-trustrow__icon snz-cart-trustrow__icon--blue">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="5" y="11" width="14" height="9" rx="2" stroke="currentColor" stroke-width="1.8"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path><circle cx="12" cy="15.5" r="1.4" fill="currentColor"></circle></svg>
              </span>
              <span>Secure Payment</span>
            </div>
            <div class="snz-cart-trustrow__item">
              <span class="snz-cart-trustrow__icon snz-cart-trustrow__icon--blue">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M3 12l6 6L21 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
              <span>100-Day Free Returns</span>
            </div>
            <div class="snz-cart-trustrow__item">
              <span class="snz-cart-trustrow__icon snz-cart-trustrow__icon--blue">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M2 7h11v9H2z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path><path d="M13 10h4l4 3.5V16h-8z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path><circle cx="6" cy="18" r="1.7" stroke="currentColor" stroke-width="1.5"></circle><circle cx="17" cy="18" r="1.7" stroke="currentColor" stroke-width="1.5"></circle></svg>
              </span>
              <span>Free Shipping €50+</span>
            </div>
          </div></div>
    `,
  upsell: () => `<div class="cpu-wrap">
    <h3 class="cpu-heading">Complete your sleep set</h3>
    <div class="cpu-item">
      <div class="cpu-item__image">
        <img src="${MASK_IMG}" alt="Navy Sleep Mask" loading="lazy" width="64" height="64">
      </div>
      <div class="cpu-item__content">
        <span class="cpu-item__title">Navy Sleep Mask</span>
        <span class="cpu-item__sub">Blocks out all light. Zero pressure on the eyes.</span>
        <div class="cpu-item__row">
          <span class="cpu-item__price">+€20,00</span>
          <button type="button" class="cpu-item__btn" data-mask-add="" data-variant-id="${MASK}">+ Add</button>
        </div>
      </div>
    </div>
  </div>`,
  progress: ({ remaining, pct }) => `<div class="cart-progress">
  <div class="cart-progress__header">
    <p class="cart-progress__text">
      
        Spend 
    <span>${remaining}</span>
 more to unlock FREE shipping!
      
    </p>
    <div class="cart-progress__goal">
      <span class="cart-progress__goal-amount">€50</span>
      <span class="cart-progress__goal-label">Free shipping</span>
    </div>
  </div>
  <div class="cart-progress__bar">
    <div class="cart-progress__bar__progress" style="width: ${pct}%;">
      <div class="cart-progress__bar__badge"><svg class="icon icon-accordion color-foreground-text" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M0 3.75156C0 3.47454 0.224196 3.24997 0.500755 3.24997H10.647C10.9235 3.24997 11.1477 3.47454 11.1477 3.75156V5.07505V5.63362V6.10938V13.6616C10.9427 14.0067 10.8813 14.1101 10.5516 14.6648L7.22339 14.6646V13.6614H10.1462V4.25316H1.00151V13.6614H2.6842V14.6646H0.500755C0.224196 14.6646 0 14.44 0 14.163V3.75156Z"></path>
      <path d="M18.9985 8.08376L11.1477 6.10938V5.07505L19.6212 7.20603C19.8439 7.26203 20 7.46255 20 7.69253V14.1631C20 14.4401 19.7758 14.6647 19.4992 14.6647H17.3071V13.6615H18.9985V8.08376ZM11.1477 13.6616L13.3442 13.6615L13.3443 14.6647L10.5516 14.6648L11.1477 13.6616Z"></path>
      <path d="M7.71269 14.1854C7.71269 15.6018 6.56643 16.75 5.15245 16.75C3.73847 16.75 2.59221 15.6018 2.59221 14.1854C2.59221 12.7691 3.73847 11.6209 5.15245 11.6209C6.56643 11.6209 7.71269 12.7691 7.71269 14.1854ZM5.15245 15.7468C6.01331 15.7468 6.71118 15.0478 6.71118 14.1854C6.71118 13.3231 6.01331 12.6241 5.15245 12.6241C4.29159 12.6241 3.59372 13.3231 3.59372 14.1854C3.59372 15.0478 4.29159 15.7468 5.15245 15.7468Z"></path>
      <path d="M17.5196 14.1854C17.5196 15.6018 16.3733 16.75 14.9593 16.75C13.5454 16.75 12.3991 15.6018 12.3991 14.1854C12.3991 12.7691 13.5454 11.6209 14.9593 11.6209C16.3733 11.6209 17.5196 12.7691 17.5196 14.1854ZM14.9593 15.7468C15.8202 15.7468 16.5181 15.0478 16.5181 14.1854C16.5181 13.3231 15.8202 12.6241 14.9593 12.6241C14.0985 12.6241 13.4006 13.3231 13.4006 14.1854C13.4006 15.0478 14.0985 15.7468 14.9593 15.7468Z"></path></svg>
</div>
    </div>
  </div>
</div>

      
      `,
  progressDone: () => `<div class="cart-progress">
  <div class="cart-progress__header">
    <p class="cart-progress__text">
      
        Congratulations! You've unlocked FREE shipping!
      
    </p>
    <div class="cart-progress__goal">
      <span class="cart-progress__goal-amount">€50</span>
      <span class="cart-progress__goal-label">Free shipping</span>
    </div>
  </div>
  <div class="cart-progress__bar">
    <div class="cart-progress__bar__progress" style="width: 100%;">
      <div class="cart-progress__bar__badge is-complete"><svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M4 12.5l5 5L20 6" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
    </div>
  </div>
</div>

      
      `,
  drawerRow: ({ n, id, handle, img, title, options, discounts, price, minusDisabled, qty }) => `<tr id="CartDrawer-Item-${n}" class="cart-item" role="row">
                          <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">
                            
                              
                              <a href="/products/${handle}?variant=${id}" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a>
                              ${img}
                            
                          </td>

                          <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><a href="/products/${handle}?variant=${id}" class="cart-item__name h4 break">${title}</a><dl>${options}</dl>

                              <p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount">${discounts}</ul>
                          </td>

                          <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">
                            <div class="loading-overlay hidden">
                              <div class="loading-overlay__spinner">
                                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                </svg>
                              </div>
                            </div>

                            <div class="cart-item__price-wrapper">${price}</div>
                          </td>

                          <td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">
                            <div class="cart-item__quantity-wrapper">
                              <quantity-input class="quantity cart-quantity">
                                <button class="quantity__button no-js-hidden${minusDisabled}" name="minus" type="button">
                                  <span class="visually-hidden">Decrease quantity for ${title}</span>
                                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
</path></svg>

                                </button>
                                <input class="quantity__input" type="number" data-quantity-variant-id="${id}" name="updates[]" value="${qty}" data-cart-quantity="${qty}" min="1" step="1" aria-label="Quantity for ${title}" id="Drawer-quantity-${n}" data-index="${n}" style="">
                                <button class="quantity__button no-js-hidden" name="plus" type="button">
                                  <span class="visually-hidden">Increase quantity for ${title}</span>
                                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
</path></svg>

                                </button>
                              </quantity-input>

                              <cart-remove-button id="CartDrawer-Remove-${n}" data-index="${n}">
                                <button type="button" class="button button--tertiary" aria-label="Remove ${title}">
                                  <span class="cart-remove-button-label" aria-hidden="true">Remove</span>
                                </button>
                              </cart-remove-button>
                            </div>

                            <div id="CartDrawer-LineItemError-${n}" class="cart-item__error" role="alert">
                              <small class="cart-item__error-text"></small>
                              <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                                <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                                <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
                              </svg>
                            </div>
                          </td>
                        </tr>`,
  option: ({ name, value }) => `<div class="product-option">
                                      <dt>${name}:</dt>
                                      <dd>
                                        ${value}
                                      </dd>
                                    </div>`,
  property: ({ name, value }) => `<div class="product-option">
                                      <dt>${name}:</dt>
                                      <dd>${value}
</dd>
                                    </div>`,
  discount: ({ title }) => `<li class="discounts__discount">
                                  ${title}
                                </li>`,
  price: ({ price }) => `<span class="price price--end">
                                  ${price}
                                </span>`,
  discountedPrice: ({ final, orig }) => `<div class="cart-item__discounted-prices">
                                  <span class="visually-hidden">
                                    Sale price
                                  </span>
                                  <span class="price price--end">
                                    ${final}
                                  </span>
                                  <span class="visually-hidden">
                                    Regular price
                                  </span>
                                  <s class="cart-item__old-price price price--end">
                                    ${orig}
                                  </s>
                                </div>`,
  totalOriginal: ({ v }) => `<span class="cart-drawer__original-total">${v}</span>`,
  totalSavings: ({ v }) => `<span class="cart-drawer__savings-badge">You save ${v}</span>`,
  cartTable: ({ rows }) => `<table class="cart-items">
            <caption class="visually-hidden">
              Your cart
            </caption>
            <thead>
              <tr>
                <th class="caption-with-letter-spacing" colspan="2" scope="col">
                  Product
                </th>
                <th class="medium-hide large-up-hide right caption-with-letter-spacing" colspan="1" scope="col">
                  Total
                </th>
                <th class="cart-items__heading--wide small-hide caption-with-letter-spacing" colspan="1" scope="col">
                  Quantity
                </th>
                <th class="small-hide right caption-with-letter-spacing" colspan="1" scope="col">
                  Total
                </th>
              </tr>
            </thead>

            <tbody>${rows}</tbody>
          </table>`,
  cartRow: ({ n, id, handle, img, title, unit, options, discounts, priceMobile, price, minusDisabled, qty }) => `<tr class="cart-item" id="CartItem-${n}">
                  <td class="cart-item__media">
                    
                      
                      <a href="/products/${handle}?variant=${id}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
                      <div class="cart-item__image-container gradient global-media-settings">
                        ${img}
                      </div>
                    
                  </td>

                  <td class="cart-item__details"><a href="/products/${handle}?variant=${id}" class="cart-item__name h4 break">${title}</a>${unit}<dl>${options}</dl>

                      <p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount">${discounts}</ul>
                  </td>

                  <td class="cart-item__totals right medium-hide large-up-hide">
                    <div class="loading-overlay hidden">
                      <div class="loading-overlay__spinner">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </div>
                    <div class="cart-item__price-wrapper">${priceMobile}</div>
                  </td>

                  <td class="cart-item__quantity">
                    <div class="cart-item__quantity-wrapper">
                      <label class="visually-hidden" for="Quantity-${n}">
                        Quantity
                      </label>
                      <quantity-input class="quantity cart-quantity">
                        <button class="quantity__button no-js-hidden${minusDisabled}" name="minus" type="button">
                          <span class="visually-hidden">Decrease quantity for ${title}</span>
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
</path></svg>

                        </button>
                        <input class="quantity__input" data-quantity-variant-id="${id}" type="number" name="updates[]" value="${qty}" data-cart-quantity="${qty}" min="1" step="1" aria-label="Quantity for ${title}" id="Quantity-${n}" data-index="${n}" style="">
                        <button class="quantity__button no-js-hidden" name="plus" type="button">
                          <span class="visually-hidden">Increase quantity for ${title}</span>
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
</path></svg>

                        </button>
                      </quantity-input>

                      <cart-remove-button id="Remove-${n}" data-index="${n}">
                        <a href="/cart/change?id=${id}&amp;quantity=0" class="button button--tertiary" aria-label="Remove ${title}">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
  <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
  <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
</svg>

                        </a>
                      </cart-remove-button>
                    </div>
                    <div class="cart-item__error" id="Line-item-error-${n}" role="alert">
                      <small class="cart-item__error-text"></small>
                      <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                        <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
                      </path></svg>
                    </div>
                  </td>

                  <td class="cart-item__totals right small-hide">
                    <div class="loading-overlay hidden">
                      <div class="loading-overlay__spinner">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </div>

                    <div class="cart-item__price-wrapper">${price}</div>
                  </td>
                </tr>`,
  cartUnit: ({ price }) => `<div class="product-option">
                        ${price}
                      </div>`,
  cartUnitDiscounted: ({ orig, final }) => `<div class="cart-item__discounted-prices">
                        <span class="visually-hidden">
                          Regular price
                        </span>
                        <s class="cart-item__old-price product-option">${orig}</s>
                        <span class="visually-hidden">
                          Sale price
                        </span>
                        <strong class="cart-item__final-price product-option">
                          ${final}
                        </strong>
                      </div>`,
  cartDiscount: ({ title }) => `<li class="discounts__discount"><svg aria-hidden="true" focusable="false" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
</path></svg>
${title}
                        </li>`,
  cartPrice: ({ price }) => `<span class="price price--end">
                          ${price}
                        </span>`,
  cartPriceDiscounted: ({ orig, final }) => `<dl class="cart-item__discounted-prices">
                          <dt class="visually-hidden">
                            Regular price
                          </dt>
                          <dd>
                            <s class="cart-item__old-price price price--end">
                              ${orig}
                            </s>
                          </dd>
                          <dt class="visually-hidden">
                            Sale price
                          </dt>
                          <dd class="price price--end">
                            ${final}
                          </dd>
                        </dl>`,
  imgDrawer: ({ src, alt, w, h }) => `<img class="cart-item__image" src="${src}" alt="${alt}" loading="eager" width="${w}" height="${h}">`,
  imgCart: ({ src, alt, w, h }) => `<img src="${src}" class="cart-item__image" alt="${alt}" loading="eager" width="${w}" height="${h}">`,
 };

  /* ---------- Shopify-gegevens (uit Liquid, layout/theme.liquid: window.SZ) ---------- */
  var SZ = window.SZ || { products: {} };
  function prod(h) { return SZ.products[h] || { variants: [] }; }
  function vid(h) { var v = prod(h).variants[0]; return v ? v.id : 0; }
  function compareOf(id) {
    for (var h in SZ.products) {
      var vs = SZ.products[h].variants || [];
      for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i].compare_at_price || 0;
    }
    return 0;
  }
  var THRESHOLD = 5000;
  var PILLOW = 'improved-leg-pillow';
  var EBOOK = vid('the-side-sleepers-guide-e-book'), COVER = vid('snoozer-pillow-cover'), MASK = vid('snoozer-sleep-mask');
  var SNOOZER = vid('anti-stop-snoring-mouth-guard-pro'), PRO = vid('sleep-guard-pro-plus');
  var MASK_IMG = prod('snoozer-sleep-mask').image || '';
  var PILLOW_COMPARE = (prod(PILLOW).variants[0] || {}).compare_at_price || 8000;
  var EBOOK_VALUE = compareOf(EBOOK) || 1900;
  var WAS_HANDLES = ['snoozer-pillow-cover', 'snoozer-sleep-mask'];

  /* ---------- Shopify AJAX Cart API ---------- */
  function api(url, body) {
    var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }
                   : { headers: { 'Accept': 'application/json' } };
    return fetch(url, opt).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Cart error'); e.data = j; throw e; } return j; });
    });
  }
  var lines = [], cartData = null;
  function fromCart(c) {
    cartData = c;
    lines = c.items.map(function (it) { return { key: it.key, id: it.variant_id, qty: it.quantity, props: it.properties || {}, it: it }; });
  }
  function fetchCart() { return api('/cart.js').then(function (c) { fromCart(c); return c; }); }
  var GIFT_IMG = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 150 150'%3E%3Crect width='150' height='150' rx='14' fill='%23EEF5FF'/%3E%3Crect x='35' y='62' width='80' height='58' rx='6' fill='%2368A7FA'/%3E%3Crect x='29' y='48' width='92' height='20' rx='5' fill='%233d6fc9'/%3E%3Crect x='70' y='48' width='10' height='72' fill='%23ffffff'/%3E%3Cpath d='M75 48c-6-14-26-16-26-4 0 8 14 6 26 4zm0 0c6-14 26-16 26-4 0 8-14 6-26 4z' fill='none' stroke='%233d6fc9' stroke-width='5'/%3E%3Ctext x='75' y='102' font-family='Arial' font-weight='700' font-size='26' text-anchor='middle' fill='%23ffffff'%3E%3F%3C/text%3E%3C/svg%3E";
  function qtyOf(id) { return lines.reduce(function (s, l) { return s + (l.id === id ? l.qty : 0); }, 0); }
  function hasPillow() { return lines.some(function (l) { return l.it.handle === PILLOW; }); }
  // Live gift-regels: e-book bij het kussen (max 1), gift-masker alleen samen met Snoozer Pro
  function applyGiftRules() {
    var upd = {}, add = null, n = 0;
    var ebooks = lines.filter(function (l) { return l.id === EBOOK; });
    if (EBOOK && hasPillow() && !ebooks.length) add = { id: EBOOK, quantity: 1 };
    else if (!hasPillow()) ebooks.forEach(function (l) { upd[l.key] = 0; n++; });
    else { ebooks.forEach(function (l, i) { if (i > 0) { upd[l.key] = 0; n++; } else if (l.qty > 1) { upd[l.key] = 1; n++; } }); }
    if (!qtyOf(PRO)) lines.forEach(function (l) { if (l.id === MASK && l.props && l.props._gift) { upd[l.key] = 0; n++; } });
    // Live cart-guard: de hoes hoort bij het kussen, het masker bij het kussen of een Snoozer/Snoozer Pro
    var guard = qtyOf(SNOOZER) || qtyOf(PRO);
    lines.forEach(function (l) {
      if (upd[l.key] === 0) return;
      if ((l.id === COVER && !hasPillow()) || (l.id === MASK && !hasPillow() && !guard)) { upd[l.key] = 0; n++; }
    });
    var p = Promise.resolve();
    if (n) p = p.then(function () { return api('/cart/update.js', { updates: upd }); });
    if (add) p = p.then(function () { return api('/cart/add.js', { items: [add] }); });
    if (!n && !add) return Promise.resolve(cartData);
    return p.then(fetchCart);
  }
  var fromAdd = false;
  function commit(add) {
    fromAdd = !!add;
    return applyGiftRules().then(render);
  }
  function fail(e) { if (window.console) console.error('[sz-cart]', e); return fetchCart().then(render, function () {}); }

  /* ---------- berekeningen ---------- */
  function fmt(c) {
    var s = (c / 100).toFixed(2).split('.');
    return '€' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1];
  }
  function variantInfo(l) {
    var it = l.it, im = it.featured_image || {};
    var src = it.image || im.url || '';
    if (src) src += (src.indexOf('?') === -1 ? '?' : '&amp;') + 'width=300';
    var ratio = im.aspect_ratio || 1;
    var opt = null;
    if (!it.product_has_only_default_variant && it.options_with_values && it.options_with_values.length) opt = [it.options_with_values[0].name, it.options_with_values[0].value];
    return {
      title: it.product_title, handle: it.handle, price: it.original_price, option: opt,
      was: WAS_HANDLES.indexOf(it.handle) !== -1 ? compareOf(it.variant_id) : 0,
      img: { src: src, alt: im.alt || '', w: 150, h: Math.ceil(150 / ratio) }
    };
  }
  function compute() {
    var total = 0, original = 0, count = 0;
    var rows = lines.map(function (l) {
      var v = variantInfo(l), it = l.it, line = it.original_line_price, final = it.final_line_price;
      var free = v.price ? Math.round((line - final) / v.price) : 0;
      total += final; count += l.qty;
      var gift = l.id === MASK && final === 0 && qtyOf(PRO) > 0;
      original += gift ? 0 : v.handle === PILLOW ? PILLOW_COMPARE * l.qty : l.id === EBOOK ? EBOOK_VALUE * l.qty : line;
      var titles = (it.line_level_discount_allocations || []).map(function (d) { return d.discount_application && d.discount_application.title; }).filter(Boolean);
      if (gift) { v.handle = 'sleep-guard-pro-plus'; v.title = '\uD83C\uDF81 Mystery Gift'; v.img = { src: GIFT_IMG, alt: 'Mystery gift', w: 150, h: 150 }; }
      return { l: l, v: v, line: line, final: final, free: free, discounts: gift ? ['Free with Snoozer Pro'] : titles.filter(function (t) { return !/mask/i.test(t); }), gift: gift };
    });
    rows.sort(function (a, b) { return (a.gift ? 1 : 0) - (b.gift ? 1 : 0); });
    if (cartData) total = cartData.total_price;
    return { rows: rows, total: total, original: original, count: count };
  }
  function optionsHtml(r) {
    var h = r.v.option ? T.option({ name: r.v.option[0], value: r.v.option[1] }) : '';
    Object.keys(r.l.props || {}).forEach(function (k) { if (k.charAt(0) !== '_' && r.l.props[k]) h += T.property({ name: k, value: r.l.props[k] }); });
    return h;
  }
  function esc(s) { return String(s).replace(/&(?!amp;)/g, '&amp;').replace(/"/g, '&quot;'); }
  function discountsHtml(r, tpl) { return r.discounts.map(function (t) { return tpl({ title: t }); }).join(''); }

  /* ---------- drawer ---------- */
  var drawer = document.querySelector('cart-drawer');
  var emptyInner = drawer && drawer.querySelector('.drawer__inner').innerHTML;
  function drawerPrice(r) {
    if (r.l.id === EBOOK) return T.price({ price: fmt(r.final) }) + '<div class="snz-gift-price"><span class="snz-gift-price__label">Free gift</span><s class="snz-cmp">' + fmt(EBOOK_VALUE) + '</s></div>';
    if (r.gift) return '<div class="snz-gift-price"><span class="snz-gift-price__label">FREE</span></div>';
    var h = r.final < r.line ? T.discountedPrice({ final: fmt(r.final), orig: fmt(r.line) }) : T.price({ price: fmt(r.final) });
    if (r.v.handle === PILLOW) h += '<s class="snz-cmp">' + fmt(PILLOW_COMPARE * r.l.qty) + '</s>';
    else if (r.v.was) h += '<s class="qb-was">' + fmt(r.v.was * r.l.qty) + '</s>';
    return h;
  }
  function renderDrawer(c) {
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    var open = drawer.classList.contains('active');
    if (!c.rows.length) {
      // Live (Dawn): na een add haalt renderContents 'is-empty' weg; na −/Remove zet cart.js 'is-empty' terug
      var cls = 'drawer ' + (fromAdd ? '' : 'is-empty ') + 'qb-is-empty';
      if (drawer.className.replace(/ ?animate| ?active/g, '') === cls) return;
      inner.innerHTML = emptyInner;
      drawer.className = cls + (open ? ' animate active' : '');
      return;
    }
    var rows = c.rows.map(function (r, i) {
      return T.drawerRow({
        n: lines.indexOf(r.l) + 1, id: r.l.id, handle: r.v.handle, title: r.gift ? r.v.title.replace(/^Snoozer\s+/, '') : r.v.title, qty: r.l.qty,
        img: T.imgDrawer({ src: r.v.img.src, alt: esc(r.v.img.alt), w: r.v.img.w, h: r.v.img.h }),
        options: optionsHtml(r), discounts: discountsHtml(r, T.discount),
        price: drawerPrice(r), minusDisabled: r.l.qty <= 1 ? ' disabled' : ''
      }).replace('class="cart-item"', r.gift ? 'class="cart-item is-gift"' : 'class="cart-item"');
    }).join('');
    var progress = c.total >= THRESHOLD ? T.progressDone() : T.progress({ remaining: fmt(THRESHOLD - c.total), pct: Math.floor(c.total * 1000 / THRESHOLD) / 10 });
    var saving = c.original > c.total;
    inner.innerHTML = T.drawerInner({
      count: c.count, progress: progress, rows: rows, total: fmt(c.total),
      original: saving ? T.totalOriginal({ v: fmt(c.original) }) : '', savings: saving ? T.totalSavings({ v: fmt(c.original - c.total) }) : '',
      upsell: qtyOf(SNOOZER) && !qtyOf(MASK) && MASK ? T.upsell() : ''
    });
    drawer.className = 'drawer' + (open ? ' animate active' : '');
    if (window.szbInsert) window.szbInsert(inner);
  }
  function openDrawer() {
    if (!drawer) { location.href = '/cart'; return; }
    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
  if (drawer) { drawer.open = openDrawer; drawer.close = closeDrawer; }

  /* ---------- header-bolletje ---------- */
  function renderBubble(c) {
    document.querySelectorAll('#cart-icon-bubble').forEach(function (a) {
      var b = a.querySelector('.cart-count-bubble');
      if (!c.count) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
      b.innerHTML = '<span aria-hidden="true">' + c.count + '</span><span class="visually-hidden">' + c.count + (c.count === 1 ? ' item' : ' items') + '</span>\n  ';
    });
  }

  /* ---------- /cart pagina ---------- */
  var cartItems = document.querySelector('cart-items');
  var cartFooter = document.getElementById('main-cart-footer');
  var cartEmptyHtml = cartItems && cartItems.querySelector('#main-cart-items .js-contents').innerHTML;
  function renderCartPage(c) {
    if (!cartItems) return;
    var empty = !c.rows.length;
    if (empty && cartItems.classList.contains('is-empty') && !cartItems.classList.contains('sz-pending')) return;
    cartItems.className = 'page-width ' + (empty ? 'is-empty' : 'section-template--31100497887572__cart-items-padding');
    cartItems.querySelector('#main-cart-items .js-contents').innerHTML = empty ? cartEmptyHtml : T.cartTable({
      rows: c.rows.map(function (r, i) {
        var disc = r.final < r.line;
        return T.cartRow({
          n: lines.indexOf(r.l) + 1, id: r.l.id, handle: r.v.handle, title: r.gift ? r.v.title.replace(/^Snoozer\s+/, '') : r.v.title, qty: r.l.qty,
          unit: disc ? T.cartUnitDiscounted({ orig: fmt(r.v.price), final: fmt(Math.round(r.final / r.l.qty)) }) : T.cartUnit({ price: fmt(r.v.price) }),
          img: T.imgCart({ src: r.v.img.src, alt: esc(r.v.img.alt), w: r.v.img.w, h: r.v.img.h }),
          options: optionsHtml(r), discounts: discountsHtml(r, T.cartDiscount),
          // live qb-script zet de "was"-prijs alleen in de mobiele prijskolom
          priceMobile: r.gift ? drawerPrice(r) : (disc ? T.cartPriceDiscounted({ final: fmt(r.final), orig: fmt(r.line) }) : T.cartPrice({ price: fmt(r.final) })) + (r.v.was ? '<s class="qb-was">' + fmt(r.v.was * r.l.qty) + '</s>' : ''),
          price: r.gift ? drawerPrice(r) : disc ? T.cartPriceDiscounted({ final: fmt(r.final), orig: fmt(r.line) }) : T.cartPrice({ price: fmt(r.final) }),
          minusDisabled: r.l.qty <= 1 ? ' disabled' : ''
        }).replace('class="cart-item"', r.gift ? 'class="cart-item is-gift"' : 'class="cart-item"');
      }).join('')
    });
    if (cartFooter) {
      cartFooter.className = 'page-width' + (empty ? ' is-empty' : '');
      var v = cartFooter.querySelector('.totals__subtotal-value'); if (v) v.textContent = fmt(c.total) + ' EUR';
      var btn = cartFooter.querySelector('#checkout'); if (btn) btn.disabled = empty;
    }
  }

  function render() { var c = compute(); renderDrawer(c); renderBubble(c); renderCartPage(c); }

  /* ---------- toevoegen ---------- */
  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  // Kussen-bundels zoals de live quantity-break: 1 = kussen, 2 = kussen + hoes, 3 = Sleep Kit (kussen + hoes + masker)
  function pillowItems(form) {
    var radio = document.querySelector('input[name="quantity"]:checked');
    var label = radio && document.querySelector('label[for="' + radio.id + '"]');
    var sel = label && label.querySelector('select.quantity-break__variant-select');
    var id = +(sel ? sel.value : String(form.querySelector('[name="id"]').value).split(',')[0]);
    var items = [[id, 1]];
    if (radio && (radio.id === 'quantity2' || radio.id === 'quantity3') && COVER) items.push([COVER, 1]);
    if (radio && radio.id === 'quantity3' && MASK) items.push([MASK, 1]);
    return items;
  }
  function itemsFromForm(form) {
    var idEl = form.querySelector('[name="id"]');
    if (!idEl) return null;
    var items, fid = form.getAttribute('id') || '';
    if ((handle === PILLOW || (form.closest('quick-add-modal') && String(idEl.value).indexOf(',') !== -1)) && !/^quick-add/.test(fid)) items = pillowItems(form); // id-veld bevat hier de bundel "kussen,hoes,masker" (ook in de quick-add-modal)
    else if (!+idEl.value) return null;
    else if (/^quick-add/.test(fid)) items = [[+idEl.value, 1]];
    else {
      var q = document.querySelector('input[name="quantity"][form="' + fid + '"]:checked') || form.querySelector('[name="quantity"]');
      items = [[+idEl.value, Math.max(1, parseInt(q && q.value, 10) || 1)]];
    }
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (p) { if (!p.disabled && p.value) props[p.name.slice(11, -1)] = p.value; });
    return items.map(function (it) { var o = { id: it[0], quantity: it[1] }; if (Object.keys(props).length) o.properties = props; return o; });
  }
  // Shopify voegt elke nieuwe regel bovenaan toe; de laatste in de lijst komt dus bovenaan (zoals de lokale kopie)
  function addItems(items) { return api('/cart/add.js', { items: items }).then(fetchCart); }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    var ret = form.querySelector('[name="return_to"]');
    if (ret && /checkout/.test(ret.value)) return; // Snoozer-hero "Check Out": gewoon Shopify-form -> direct naar checkout (zoals live)
    var items = itemsFromForm(form);
    if (!items) return;
    e.preventDefault();
    addItems(items).then(function () { return commit(true); }).then(openDrawer, function (err) { fail(err).then(openDrawer); });
  }, true);

  // Snoozer-pagina (live srxBuy): eerst Snoozer/Pro/masker weg, dan de keuze (+ masker als gift bij Pro)
  window.SRX = window.SRX || {};
  window.SRX.pro = { id: SNOOZER, name: 'Snoozer' };
  window.SRX.plus = { id: PRO, name: 'Snoozer Pro' };
  window.SRX.maskId = MASK;
  window.SRX.selected = window.SRX.selected || 'plus';
  window.srxBuy = function (which, btn) {
    var key = which || window.SRX.selected || 'plus';
    var item = window.SRX[key]; if (!item || !item.id) return;
    if (btn && btn.dataset.busy) return;
    var restore = function () { if (btn && btn.dataset.busy) { btn.innerHTML = btn.dataset.label; btn.style.pointerEvents = ''; delete btn.dataset.busy; } };
    if (btn) { btn.dataset.busy = '1'; btn.dataset.label = btn.innerHTML; btn.innerHTML = 'Adding...'; btn.style.pointerEvents = 'none'; }
    var items = [{ id: item.id, quantity: 1 }];
    if (key === 'plus' && MASK) items.push({ id: MASK, quantity: 1, properties: { _gift: 'Snoozer Pro' } });
    var upd = {}; upd[SNOOZER] = 0; upd[PRO] = 0; if (MASK) upd[MASK] = 0;
    api('/cart/update.js', { updates: upd }).catch(function () {})
      .then(function () { return addItems(items); })
      .then(function () {
        if (!which) { location.assign('/checkout'); return; }
        return commit(true).then(function () { restore(); openDrawer(); });
      })
      .catch(function (err) { restore(); fail(err).then(openDrawer); });
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-srx-pick]');
    if (!a) return;
    window.SRX.selected = a.getAttribute('data-srx-pick');
    document.dispatchEvent(new CustomEvent('srx:select', { detail: window.SRX.selected }));
  });

  /* ---------- drawer / cart bediening ---------- */
  function setQty(i, q) {
    var l = lines[i];
    if (!l) return;
    api('/cart/change.js', { id: l.key, quantity: q }).then(function (c) { fromCart(c); return commit(false); }).catch(fail);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var icon = t.closest('#cart-icon-bubble');
    if (icon && drawer) { e.preventDefault(); render(); openDrawer(); return; }
    if (t.closest('#CartDrawer-Overlay')) { closeDrawer(); return; }
    var qb = t.closest('cart-drawer quantity-input .quantity__button, cart-items quantity-input .quantity__button');
    if (qb) {
      e.preventDefault();
      var input = qb.parentNode.querySelector('.quantity__input');
      var i = +input.getAttribute('data-index') - 1, q = lines[i] ? lines[i].qty : 0;
      if (qb.name === 'minus') { if (q > 1) setQty(i, q - 1); } else setQty(i, q + 1);
      return;
    }
    var rm = t.closest('cart-remove-button');
    if (rm) { e.preventDefault(); setQty(+rm.getAttribute('data-index') - 1, 0); return; }
    if (t.closest('[data-mask-add]')) { e.preventDefault(); if (MASK) addItems([{ id: MASK, quantity: 1 }]).then(function () { return commit(true); }).catch(fail); return; }
    var co = t.closest('#CartDrawer-Checkout, #checkout');
    if (co) { e.preventDefault(); if (!co.disabled && lines.length) location.href = '/checkout'; }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('cart-drawer .quantity__input, cart-items .quantity__input');
    if (input) setQty(+input.getAttribute('data-index') - 1, Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('active')) closeDrawer(); });

  // Kleurkeuze bovenaan (Color-swatches) => kleur-dropdowns in de bundels mee laten lopen
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (r.name !== 'Color' || handle !== PILLOW) return;
    document.querySelectorAll('select.quantity-break__variant-select').forEach(function (s) {
      [].forEach.call(s.options, function (o) { if (o.text.trim() === r.value) s.value = o.value; });
    });
  });

  // Sticky Add to cart (theme: .sticky-atc--after-scroll): zichtbaar zodra de hoofdknop boven uit beeld is
  var sticky = document.querySelectorAll('.sticky-atc--after-scroll');
  var mainBtn = document.querySelector('.product-form__submit[name="add"]');
  if (sticky.length && mainBtn) {
    var stickyTick = false;
    var stickyUpdate = function () {
      stickyTick = false;
      var on = mainBtn.getBoundingClientRect().bottom < 0;
      sticky.forEach(function (s) { s.classList.toggle('sticky-atc--active', on); });
    };
    window.addEventListener('scroll', function () { if (!stickyTick) { stickyTick = true; requestAnimationFrame(stickyUpdate); } }, { passive: true });
  }

  // Start: cart ophalen; alleen iets aan de pagina veranderen als er iets in zit (lege staat = de statische HTML)
  fetchCart().then(function () {
    if (lines.length) return commit(false);
    if (cartItems && cartItems.classList.contains('sz-pending')) render();
  }).catch(function (e) { if (window.console) console.error('[sz-cart]', e); });
})();
